class t extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.5 6L4.5 3L19.5 3L19.5 6L21 6L21 3C21 2.60218 20.842 2.22064 20.5607 1.93934C20.2794 1.65804 19.8978 1.5 19.5 1.5L4.5 1.5C4.10218 1.5 3.72065 1.65803 3.43934 1.93934C3.15804 2.22064 3 2.60217 3 3L3 6L4.5 6Z" fill="#16191D"></path><path d="M4.5 13.5L5.5575 14.5575L11.25 8.8725L11.25 22.5L12.75 22.5L12.75 8.8725L18.4425 14.5575L19.5 13.5L12 6L4.5 13.5Z" fill="#16191D"></path></svg>';
  }
}
const L = "pwc-icon-upload";
customElements.get(L) || customElements.define(L, t);
